import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ApplicationEventActionService {
    constructor() {}

    private proceedToNotesSubject = new Subject<void>();
    proceedToNotes$ = this.proceedToNotesSubject.asObservable();

    private createTemplateSubject = new Subject<void>();
    createTemplate$ = this.createTemplateSubject.asObservable();

    private deleteSubject = new Subject<void>();
    deleteClick$ = this.deleteSubject.asObservable();

    /**
     * Emits an event to signal that the "Proceed to Notes" button was clicked.
     */
    triggerProceedToNotesClick(): void {
        this.proceedToNotesSubject.next();
    }

    /**
     * Emits an event to signal that the "Create Template" button was clicked.
     */
    triggerCreateTemplateClick(): void {
        this.createTemplateSubject.next();
    }

    /**
     * Emits an event to signal that the "Delete" button was clicked.
     */
    triggerDeleteClick(): void {
        this.deleteSubject.next();
    }
}
